module.exports = __webpack_public_path__ + "static/header-white-49986287525d26854853d4ba10a7a3ec.svg";